import { useId } from 'react'
import type { IsoDate } from '@henlytics/types'

export interface DateCellProps {
  label: string
  value: IsoDate
  onChange: (value: IsoDate) => void
  max?: IsoDate
  disabled?: boolean
  hint?: string
}

/**
 * Back-dated entry is legitimate and is never blocked (§3.9) — the farm often
 * enters two or three days at once. There is deliberately no minimum date.
 */
export function DateCell({ label, value, onChange, max, disabled, hint }: DateCellProps) {
  const id = useId()
  return (
    <label className="cell" htmlFor={id}>
      <span className="cell-label">{label}</span>
      <input
        id={id}
        className="cell-input"
        type="date"
        value={value}
        max={max}
        disabled={disabled}
        onChange={(event) => onChange(event.target.value)}
      />
      {hint ? <span className="cell-hint">{hint}</span> : null}
    </label>
  )
}
